import { createFileRoute } from '@tanstack/react-router'

import {
	getGetMeOptions,
	preloadGetInventorySettings,
	preloadGetMe,
	preloadListInventoryLocations
} from '@/api/react-query'
import { isAdminOrDeveloperRole } from '@/util/invite-role-label'

export const Route = createFileRoute('/_authenticated/settings/inventory')({
	loader: async ({ context }) => {
		await preloadGetInventorySettings(context, {})
		await preloadGetMe(context, {})
		const me = await context.queryClient.fetchQuery(getGetMeOptions(context.api, {}))
		if (isAdminOrDeveloperRole(me.role)) {
			await preloadListInventoryLocations(context, { query: { limit: 100, offset: 0 } })
		}
	},
	staticData: { crumb: ({ context: { L } }) => L.Inventory.Settings.Title() }
})
